<template>
  <div class="contents_wrapper">
    <div class="contents">
      <h2 class="large_label">パスワード再設定</h2>

      <p class="bold_label">メールアドレス</p>
      <input type="text" class="text_form" v-model="authData.email"/>

      <button @click="resetPass()" class="active-rectangle_button">リセットメールを送信</button>

    </div>

    <p><router-link class="underline_label" :to="{ name: 'RegistrationUser'}">新規登録はこちら</router-link></p>
  </div>
</template>

<script>
  import toast from '@/assets/js/functions/_core/toast';

  import auth from '@/assets/js/functions/firebase/auth/auth';
  import users from '@/assets/js/functions/firebase/auth/users';

  export default {
    name: "PasswordReset",

    mixins: [toast, auth, users],

    data() {
      return {
        authData: {
          email: '',
          password: '',
        },
      }
    },

    methods: {
      isValidLogin() {
        if (!this.authData.email) {
          this.showErrorMessage('メールアドレスが未入力です。');
          return false;
        }
        return true;
      },

      async resetPass() {
        if (!this.isValidLogin()) return;
        await this.passwordReset(this.authData.email).then(() => {
          this.showSuccessMessage('パスワード再設定のメールが送信されました。');
          this.$router.push({name: 'Top', force: true});
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    > .contents {
      @include form-contents();

      align-items: center;

      > .underline_label {
        margin-bottom: 2rem;
      }
    }

    > p {
      width: 100%;
      text-align: center;
    }
  }
</style>